<template>
  <div class="soil-data-table-overview">
    <div class="overview-table-row">
      <div class="overview-table">
        <MeasurementObjectsSelectTable
          :projectId="$route.params.projectId"
          :projectCode="projectCode"
          :updateSelectedRows="() => {}"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          @update:selected="onUpdateMeasurementObject"
        />
      </div>
      <div class="overview-table">
        <FieldSamplesTable
          :projectId="$route.params.projectId"
          :projectCode="projectCode"
          :selectedMeasurementObject="measurementObject"
          :enableCreateTableRowAction="enableCreateTableRowAction"
          :enableDeleteTableRowAction="enableDeleteTableRowAction"
          :enableUpdateTableRowAction="enableUpdateTableRowAction"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          :enableExportSettings="enableExportSettings"
        />
      </div>
    </div>
    <div class="overview-table-row">
      <div class="overview-table">
        <LayersTable
          :projectId="$route.params.projectId"
          :projectCode="projectCode"
          :selectedMeasurementObject="measurementObject"
          :enableCreateTableRowAction="enableCreateTableRowAction"
          :enableDeleteTableRowAction="enableDeleteTableRowAction"
          :enableUpdateTableRowAction="enableUpdateTableRowAction"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          :enableExportSettings="enableExportSettings"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { MeasurementObjectsSelectTable, FieldSamplesTable, LayersTable } from '@/components/dynamicTables/tables'
import Popup from '@/utils/popup'
import Config from '@/configurations/config'
import stringUtils from '@/utils/stringUtils'

const TiPopup = Popup[Config.platform].default

export default {
  name: 'soilDataTableOverview',
  components: {
    MeasurementObjectsSelectTable,
    FieldSamplesTable,
    LayersTable
  },
  props: {
    enableCreateTableRowAction: {
      required: false,
      default() {
        return true
      }
    },
    enableDeleteTableRowAction: {
      required: false,
      default() {
        return true
      }
    },
    enableUpdateTableRowAction: {
      required: false,
      default() {
        return true
      }
    },
    enableColumnChooser: {
      required: false,
      default() {
        return true
      }
    },
    searchPanelEnabled: {
      required: false,
      default() {
        return true
      }
    },
    enableExportSettings: {
      required: false,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      measurementObject: {},
      projectCode: ''
    }
  },
  async created() {
    await this.setCurrentProject()
  },
  methods: {
    async onUpdateMeasurementObject(data) {
      // if (data && Array.isArray(data) && data.length === 1) {
      //   this.measurementObject = data[0]
      // } else {
      //   this.measurementObject = {}
      // }
      this.measurementObject = data
    },
    async setCurrentProject() {
      if (stringUtils.isNullOrEmptyOrWhitespace(this.$route.params.projectId)) {
        TiPopup.popup(this.$t('message.projectNotFound'))
        return
      }

      await this.$store.dispatch('fetchProject', {
        PrID: this.$route.params.projectId
      })
      const project = this.$store.state.currentProject

      if (project && project.PrID) {
        this.projectCode = project.PrCode
      } else {
        TiPopup.popup(this.$t('message.projectNotFound'))
      }
    },
    async handleErrorResponse(error, errorMessage = 'message.UnknownError') {
      console.log(error)
      TiPopup.popup(this.$t(errorMessage))
    }
  }
}
</script>

<style>
.soil-data-table-overview h2 {
  margin-top: 5px;
  font-size: 20px;
}
.soil-data-table-overview {
  height: 100%;
}
.soil-data-table-overview .overview-table-row {
  height: 50%;
}
.soil-data-table-overview .overview-table-row {
  display: flex;
}
.soil-data-table-overview .overview-table-row:nth-child(2) {
  padding-top: 10px;
}
.soil-data-table-overview .overview-table-row:first-child .overview-table:first-child {
  flex: 2;
}
.soil-data-table-overview .overview-table-row:first-child .overview-table:nth-child(2) {
  flex: 8;
}
.soil-data-table-overview .overview-table-row:nth-child(2) .overview-table:first-child {
  flex: 6;
}
.soil-data-table-overview .overview-table-row .overview-table > div {
  margin-left: 10px;
}
.soil-data-table-overview .overview-table {
  overflow: hidden;
}
.soil-data-table-overview .overview-table > div,
.soil-data-table-overview .overview-table > div > div {
  height: 100%;
}
.soil-data-table-overview .overview-table-row > div,
.soil-data-table-overview .overview-table-row > div > div {
  height: 100%;
}
.dx-datagrid-search-panel {
  margin-left: 0px;
}
</style>
